import styled from "@emotion/styled";
import MuiSwitch from "@mui/material/Switch";
import { COLOR_GREY_5, COLOR_WHITE } from "../../../theme/colors";

export const StyledSwitchContainer = styled.div``;

export const StyledMuiSwitch = styled(MuiSwitch)<{ trackColor?: string }>`
  width: 47px;
  height: 24px;
  padding: 0;

  & .MuiSwitch-switchBase {
    padding: 3px;

    &.Mui-checked {
      transform: translateX(23px);
      color: ${COLOR_WHITE};

      + .MuiSwitch-track {
        background-color: ${(props) => props.trackColor || "#f44336"};
        opacity: 1;
        border: none;
      }
    }
  }

  & .MuiSwitch-thumb {
    width: 18px;
    height: 18px;
    box-shadow: none;
  }

  & .MuiSwitch-track {
    border-radius: 12px;
    background-color: ${COLOR_GREY_5};
    opacity: 1;
    width: 47px;
    height: 24px;
    transition: background-color 0.3s;
  }

  & .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track {
    opacity: 0.8;
  }
`;
